import { Box } from '@mui/material';
import React from 'react';

interface props {
    label: string;
    icon?: React.ReactNode;
    children: React.ReactNode
}

function InputWithLegend({ label, children, icon }: props) {
    return (
        <Box
            component="fieldset"
            sx={{
                border: '1px solid #ccc',
                borderRadius: 2,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                height: "auto",
                padding: 3,
            }}
        >
            <legend style={{ padding: 3, color: "#888", textAlign: "center", fontWeight: "bold" }}>
                {
                    icon ? <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {icon}
                        {label}
                    </span> :
                        <p>{label}</p>
                }


            </legend>
            {children}
        </Box>
    );
}

export default InputWithLegend;